/* eslint-disable max-len */
/* eslint-disable no-undef */
/* eslint-disable no-empty */
import { I18n } from 'react-redux-i18n';
import purchasesRequests from '../../server/purchases';
import { addLoading, removeLoading } from './loading';
import { getCart, setItems } from './cart';
import { getUser } from './auth';

import CartUtil from '../../utils/cart';
import { loadScript, removeScript } from '../../../components/utils';
import Pagseguro from '../../services/pagseguro';
import tagManager from '../../services/tagManager';

import PURCHASE from '../../../data/purchases';

let scriptName = '';

export const setPurchaseFeedback = feedback => ({
  type: 'PURCHASE_SET_FEEDBACK',
  feedback,
});

export const initPagSeguroProcess = async () => {
  try {
    const ret = await purchasesRequests.initPagSeguroProcess();

    if (ret && ret.scriptUrl) {
      loadScript(ret.scriptUrl);
      scriptName = ret.scriptUrl;
    }
  } catch (e) { throw e; }
};

export const endPagSeguroProcess = async () => {
  try {
    if (scriptName) removeScript(scriptName);
  } catch (e) { }
};

export const getPagSeguroSessionId = async (dispatch) => {
  try {
    if (dispatch) dispatch(addLoading());
    const ret = await purchasesRequests.getPagSeguroSessionId();

    if (dispatch) dispatch(removeLoading());
    if (ret && ret.sessionId) return ret.sessionId;
  } catch (e) { }

  if (dispatch) dispatch(removeLoading());

  return false;
};

export const finalizePurchase = (
  location = {}, type, card, document, saveCard = false, paymentInfos = {}, tagManagerOpts = {}, userData = {}, cartProducts = {},
) => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const company = getState().settings.companyTag;
  const {
    pricePermission,
    purchaseCreditMinDeliveryDatePermission,
    purchaseBankSlipMinDeliveryDatePermission,
  } = getState().contracts.selected;
  const {
    cartId, clientNumber, observation, minimumBillingDate,
  } = getState().cart;
  const { taxType, taxFixedValue } = getState().settings;
  const address = { ...location };
  const { freight, hasTax } = address;
  const purchaseFeedback = getState().purchase && getState().purchase.purchaseFeedback;
  const managerEmail = getState().cart && getState().cart.managerEmail;
  const punchoutScope = getState().punchOut;

  let newAddress = {};
  if (address.isClient) newAddress = { isClient: address.isClient };
  else if (address.isLocker) newAddress = { isLocker: address.isLocker };
  else newAddress = { nameAbbr: address.nameAbbr, cep: address.cep, deliveryCode: address.deliveryCode };

  if (clientId) {
    dispatch(addLoading());

    let price;
    if (pricePermission) {
      price = CartUtil.getCartTotal(getState().cart.items, false, taxType, { hasTax, taxFixedValue }, company);
    }

    const punchoutUserId = getState().punchOut && getState().punchOut.userId;

    try {
      if (paymentInfos.paymentService === 'pagseguro' && type !== 'billing') {
        if (!Pagseguro.hasSessionId()) {
          const sessionId = await getPagSeguroSessionId();
          if (!sessionId) throw Error(I18n.t('errorPsGetSessionId'));
          if (!Pagseguro.setSessionId(sessionId)) throw Error(I18n.t('errorPsSetSessionId'));
        }

        const senderHash = await Pagseguro.getSenderHash();
        if (!senderHash) throw Error(I18n.t('errorPsSetHashSessionId'));

        paymentInfos.senderHash = senderHash;

        if (type === 'credit' && card.number) {
          paymentInfos.CreditCard = {
            CardNumber: card.number,
            Holder: card.name,
            ExpirationDate: card.expirationDate,
            Brand: card.brand,
          };
          const brandName = await Pagseguro.getBrand(card);
          if (!brandName) throw Error(I18n.t('errorPsGetBrand'));

          const tokenCard = await Pagseguro.createCardToken(card, brandName);
          if (!tokenCard) throw Error(I18n.t('errorPsCreateCardToken'));
          paymentInfos.cardToken = tokenCard;
          paymentInfos.CreditCard.CardToken = tokenCard;
        }
      }

      const paymentsPermissionsMinimumBillingDate = [PURCHASE.paymentType.BILLING];

      if (purchaseCreditMinDeliveryDatePermission) paymentsPermissionsMinimumBillingDate.push(PURCHASE.paymentType.CREDIT);
      if (purchaseBankSlipMinDeliveryDatePermission) paymentsPermissionsMinimumBillingDate.push(PURCHASE.paymentType.BANK_SLIP);

      if (minimumBillingDate && !paymentsPermissionsMinimumBillingDate.includes(type)) {
        let labelDesc = I18n.t('errorMinimumBillingDate');

        if (purchaseCreditMinDeliveryDatePermission) labelDesc += `, ${I18n.t('credit').toUpperCase()}`;
        if (purchaseBankSlipMinDeliveryDatePermission) labelDesc += `, ${I18n.t('bankSlip').toUpperCase()}`;
        throw Error(labelDesc);
      }

      const {
        products = [],
        actionField = {},
        cartItems = [],
      } = tagManagerOpts;

      const ticket = await purchasesRequests.finalize(
        clientId, cartId, price, type, card, document, newAddress, clientNumber, freight, punchoutUserId, observation,
        saveCard, paymentInfos, userData, cartProducts, minimumBillingDate, purchaseFeedback, managerEmail,
        punchoutScope,
      );

      actionField.id = ticket && ticket.id ? `${ticket.id}` : '0';

      tagManager.ecommercePurchase(products, actionField);
      tagManager.onEndCheckout(cartItems);

      if (!cartId) dispatch(setItems([]));
      else await dispatch(getCart());

      if (cartId) await dispatch(getUser());

      return ticket;
    } catch (err) {
      throw err;
    } finally {
      dispatch(removeLoading());
    }
  }
};

export const estimatePurchase = () => async (dispatch, getState) => {
  const clientId = getState().contracts.selected && getState().contracts.selected.client.id;
  const company = getState().settings.companyTag;
  const { cartId, items = [] } = getState().cart;
  const punchoutUserId = getState().punchOut && getState().punchOut.userId;
  const { pricePermission } = getState().contracts.selected;
  const { taxType } = getState().settings;
  const products = items.map(it => it.product || {});
  const purchaseFeedback = getState().purchase && getState().purchase.purchaseFeedback;
  const punchoutUserIndicator = getState().punchOut && getState().punchOut.punchoutUserIndicator;
  const punchoutScope = getState().punchOut;

  if (clientId) {
    dispatch(addLoading());

    const actionField = {};

    let price;
    if (pricePermission) {
      price = CartUtil.getCartTotal(items, false, taxType, undefined, company);
    }

    try {
      const valueItems = CartUtil.getCartTotal(items, false, taxType, undefined, company);
      actionField.revenue = `${valueItems}`;
      actionField.affiliation = 'Nortel eShop';
    } catch (e) { }

    try {
      const ticket = await purchasesRequests.estimate(
        clientId, cartId, punchoutUserId, price, purchaseFeedback, punchoutUserIndicator, punchoutScope,
      );

      actionField.id = ticket && ticket.id ? `${ticket.id}` : '0';

      tagManager.ecommercePurchase(products, actionField);
      tagManager.onEndCheckout(items);

      if (!cartId) dispatch(setItems([]));
      else await dispatch(getCart());

      return ticket;
    } catch (error) {
      throw error;
    } finally {
      dispatch(removeLoading());
    }
  }
};

export const savePurchaseFeedback = feedback => async (dispatch) => {
  dispatch(addLoading());
  try {
    dispatch(setPurchaseFeedback(feedback));
  } finally {
    dispatch(removeLoading());
  }
};

export const saveCXML = (id, clientId, cxml) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await purchasesRequests.saveCXML(id, clientId, cxml);
  } finally {
    dispatch(removeLoading());
  }
};
